module.exports = __webpack_public_path__ + "static/media/signup-bottom-shape.2c06b117.png";